import { ZMultiplacerModuleKey } from "./schemas/foundationSchema";
import { DesignLeftSideBarTabs, RoomSideBarTabs } from "./designEnums";
export var DesignDiscipline;
(function (DesignDiscipline) {
    DesignDiscipline["ARK"] = "ARK";
    DesignDiscipline["RIE"] = "RIE";
    DesignDiscipline["RIV"] = "RIV";
    DesignDiscipline["RIS"] = "RIS";
})(DesignDiscipline || (DesignDiscipline = {}));
export var DesignRole;
(function (DesignRole) {
    DesignRole["BIM_SAMORDNER"] = "BIM-samordner";
    DesignRole["PROSJEKTERANDE"] = "Prosjekterende";
    DesignRole["DISCIPLINELEDER"] = "Disiplinleder";
    DesignRole["PROSJEKTLEDER"] = "Prosjektleder";
})(DesignRole || (DesignRole = {}));
export var DesignPhase;
(function (DesignPhase) {
    DesignPhase["DETALJPROSJEKTERING"] = "Detaljprosjektering";
    DesignPhase["TIDIG_FASE"] = "Tidlig fase";
})(DesignPhase || (DesignPhase = {}));
export const DISCIPLINE_DEFINITIONS = {
    [DesignDiscipline.RIE]: {
        key: DesignDiscipline.RIE,
        label: "RIE",
        color: "#a61e4d",
        backgroundColor: "#ffe3f3",
    },
    [DesignDiscipline.RIV]: {
        key: DesignDiscipline.RIV,
        label: "RIV",
        color: "#1864ab",
        backgroundColor: "#d0ebff",
    },
    [DesignDiscipline.RIS]: {
        key: DesignDiscipline.RIS,
        label: "RIS",
        color: "#c92a2a",
        backgroundColor: "#ffe3e3",
    },
    [DesignDiscipline.ARK]: {
        key: DesignDiscipline.ARK,
        label: "ARK",
        color: "#2f9e44",
        backgroundColor: "#d3f9d8",
    },
};
export const ROLE_DEFINITIONS = {
    [DesignRole.BIM_SAMORDNER]: {
        key: DesignRole.BIM_SAMORDNER,
        label: DesignRole.BIM_SAMORDNER,
    },
    [DesignRole.PROSJEKTERANDE]: {
        key: DesignRole.PROSJEKTERANDE,
        label: DesignRole.PROSJEKTERANDE,
    },
    [DesignRole.DISCIPLINELEDER]: {
        key: DesignRole.DISCIPLINELEDER,
        label: DesignRole.DISCIPLINELEDER,
    },
    [DesignRole.PROSJEKTLEDER]: {
        key: DesignRole.PROSJEKTLEDER,
        label: DesignRole.PROSJEKTLEDER,
    },
};
export const PHASE_DEFINITIONS = {
    [DesignPhase.DETALJPROSJEKTERING]: {
        key: DesignPhase.DETALJPROSJEKTERING,
        label: "Detaljprosjektering",
    },
    [DesignPhase.TIDIG_FASE]: {
        key: DesignPhase.TIDIG_FASE,
        label: "Tidlig fase",
    },
};
export const MULTIPLACER_MODULES = [
    {
        key: ZMultiplacerModuleKey.enum.CEILING,
        defaultViewKey: "ceiling-default",
        title: "Himling",
        description: "AI-drevet himlingsprosjektering som automatisk plasserer ventiler, armaturer og tekniske enheter basert på romgeometri og faglige krav. Sørger for rask, konsistent og optimal design - hver eneste gang.",
        disciplines: [DesignDiscipline.RIE, DesignDiscipline.RIV, DesignDiscipline.RIS],
        roles: [DesignRole.PROSJEKTERANDE],
        phases: [DesignPhase.DETALJPROSJEKTERING],
    },
    {
        key: ZMultiplacerModuleKey.enum.ROOM_VALIDATION,
        defaultViewKey: "room-validation-default",
        title: "Romvalidering",
        description: "Validerer rommets importerte artikkelgrunnlag mot forekomster i dRofus. Sammenligner antall per artikkelkode på tvers av utstyr i rom, bygningsdeler og fagfaner, slik at mangler og overskytende forekomster blir enklere å finne.",
        disciplines: [DesignDiscipline.RIE, DesignDiscipline.RIV, DesignDiscipline.RIS],
        roles: [DesignRole.PROSJEKTERANDE, DesignRole.DISCIPLINELEDER, DesignRole.PROSJEKTLEDER],
        phases: [DesignPhase.DETALJPROSJEKTERING],
    },
    {
        key: ZMultiplacerModuleKey.enum.EXPLORE,
        defaultViewKey: "explore-default",
        title: "Utforsker",
        description: "Generell utforsking av prosjektdata. Bruk modulen til å navigere, søke og inspisere innhold uten å gjøre endringer.",
        disciplines: [
            DesignDiscipline.RIE,
            DesignDiscipline.RIV,
            DesignDiscipline.RIS,
            DesignDiscipline.ARK,
        ],
        roles: [
            DesignRole.PROSJEKTERANDE,
            DesignRole.DISCIPLINELEDER,
            DesignRole.PROSJEKTLEDER,
            DesignRole.BIM_SAMORDNER,
        ],
        phases: [DesignPhase.DETALJPROSJEKTERING, DesignPhase.TIDIG_FASE],
    },
    {
        key: ZMultiplacerModuleKey.enum.ROOM_NUMBERING,
        defaultViewKey: "room-numbering-default",
        title: "Romnummerering",
        description: "Beregner romnummer automatisk basert på definerte vilkår og regler. Gir konsistent romnummerering på tvers av prosjektet og gjør det enklere å kvalitetssikre navngivning og struktur.",
        disciplines: [DesignDiscipline.ARK],
        roles: [DesignRole.PROSJEKTERANDE, DesignRole.BIM_SAMORDNER],
        phases: [DesignPhase.DETALJPROSJEKTERING],
    },
    {
        key: ZMultiplacerModuleKey.enum.DROFUS_CHANGE_MANAGEMENT,
        defaultViewKey: "drofus-changes-default",
        title: "Endringshantering dRofus",
        description: "Samler dRofus-endringer i prosjektet og gjør det enklere å følge opp hva som er lagt til, fjernet eller endret i rom og artikler. Modulen åpner endringsfanen som standard slik at prosjektet raskt kan kontrollere siste dRofus-status mot modellen.",
        disciplines: [DesignDiscipline.RIE, DesignDiscipline.RIV, DesignDiscipline.RIS],
        roles: [DesignRole.PROSJEKTERANDE, DesignRole.DISCIPLINELEDER, DesignRole.PROSJEKTLEDER],
        phases: [DesignPhase.DETALJPROSJEKTERING],
        visibleForProjectNos: [10216575],
    },
];
export const isModuleVisibleForProject = (module, projectNo, isInDev) => {
    if (module.devOnly && !isInDev) {
        return false;
    }
    if (module.visibleForProjectNos == null) {
        return true;
    }
    if (projectNo == null) {
        return false;
    }
    return module.visibleForProjectNos.includes(projectNo);
};
export const getVisibleModulesForProject = (projectNo, isInDev) => {
    return MULTIPLACER_MODULES.filter((module) => isModuleVisibleForProject(module, projectNo, isInDev));
};
export const MULTIPLACER_MODULES_BY_KEY = MULTIPLACER_MODULES.reduce((acc, m) => {
    acc[m.key] = m;
    return acc;
}, {});
export const LEFT_SIDEBAR_TABS_BY_MODULE = {
    CEILING: [
        DesignLeftSideBarTabs.VIEWS,
        DesignLeftSideBarTabs.COMPONENTS,
        DesignLeftSideBarTabs.CEILING_VALIDATIONS,
        DesignLeftSideBarTabs.CEILING_HELP,
        DesignLeftSideBarTabs.CEILING_SETTINGS,
        DesignLeftSideBarTabs.DEVICE_HISTORY,
        DesignLeftSideBarTabs.MCBIMITEM_INFO,
        DesignLeftSideBarTabs.ROUTING_GRAPHS,
        DesignLeftSideBarTabs.DROFUS_CHANGES,
    ],
    ROOM_VALIDATION: [DesignLeftSideBarTabs.VIEWS, DesignLeftSideBarTabs.COMPONENTS, DesignLeftSideBarTabs.MCBIMITEM_INFO],
    EXPLORE: [DesignLeftSideBarTabs.VIEWS, DesignLeftSideBarTabs.COMPONENTS, DesignLeftSideBarTabs.MCBIMITEM_INFO],
    ROOM_NUMBERING: [DesignLeftSideBarTabs.VIEWS, DesignLeftSideBarTabs.COMPONENTS, DesignLeftSideBarTabs.MCBIMITEM_INFO],
    DROFUS_CHANGE_MANAGEMENT: [DesignLeftSideBarTabs.VIEWS, DesignLeftSideBarTabs.COMPONENTS, DesignLeftSideBarTabs.DROFUS_CHANGES],
};
export const LEFT_SIDEBAR_DEFAULT_TAB_BY_MODULE = {
    CEILING: undefined,
    ROOM_VALIDATION: undefined,
    EXPLORE: DesignLeftSideBarTabs.VIEWS,
    ROOM_NUMBERING: undefined,
    DROFUS_CHANGE_MANAGEMENT: DesignLeftSideBarTabs.DROFUS_CHANGES,
};
export const ROOM_SIDEBAR_TABS_BY_MODULE = {
    CEILING: [
        RoomSideBarTabs.CEILING_MULTIPLACER_PRODUCTS,
        RoomSideBarTabs.CEILING_AI_PREDICTIONS,
        RoomSideBarTabs.ROOM_SECTION_VIEWS,
        RoomSideBarTabs.CEILING_STANDARD_ROOM,
        RoomSideBarTabs.CEILING_VALIDATIONS,
        RoomSideBarTabs.CEILING_COMMENTS,
        RoomSideBarTabs.ROOM_DROFUS_CHANGES,
        RoomSideBarTabs.ROOM_INFO,
        RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES,
    ],
    ROOM_VALIDATION: [
        RoomSideBarTabs.ROOM_SECTION_VIEWS,
        RoomSideBarTabs.CEILING_STANDARD_ROOM,
        RoomSideBarTabs.RFP_STANDARD_ROOM_DIFF,
        RoomSideBarTabs.ROOM_INFO,
        RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES,
    ],
    EXPLORE: [
        RoomSideBarTabs.ROOM_SECTION_VIEWS,
        RoomSideBarTabs.ROOM_INFO,
    ],
    ROOM_NUMBERING: [RoomSideBarTabs.ROOM_NUMBERING_DETAILS],
    DROFUS_CHANGE_MANAGEMENT: [
        RoomSideBarTabs.ROOM_DROFUS_CHANGES,
        RoomSideBarTabs.ROOM_INFO,
        RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES,
        RoomSideBarTabs.ROOM_SECTION_VIEWS,
    ],
};
export const ROOM_SIDEBAR_DEFAULT_TAB_BY_MODULE = {
    CEILING: RoomSideBarTabs.CEILING_MULTIPLACER_PRODUCTS,
    ROOM_VALIDATION: RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES,
    EXPLORE: RoomSideBarTabs.ROOM_INFO,
    ROOM_NUMBERING: RoomSideBarTabs.ROOM_NUMBERING_DETAILS,
    DROFUS_CHANGE_MANAGEMENT: RoomSideBarTabs.ROOM_DROFUS_CHANGES,
};
